/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerBingSourceComponent', [
    '$rootScope',
    'DesignerBaseSourceAndDestinationComponent',
    'DesignerConnection',

    function ($rootScope, DesignerBaseSourceAndDestinationComponent, DesignerConnection) {
      function DesignerBingSourceComponent() {
        DesignerBaseSourceAndDestinationComponent.apply(this);

        this.connection = new DesignerConnection();
        this.api_version = null;
        this.accounts_campaigns = null;
        this.report_type = null;
        this.columns = null;
        this.report_aggregation_type = null;
        this.report_date_range_type = null;
        this.report_date_range_min = null;
        this.report_date_range_max = null;
        this.time_period_date_field_alias = null;
        this.time_period_hour_field_alias = null;
        this.time_zone = null;
        this.report_on = null;
      }

      DesignerBingSourceComponent.prototype = new DesignerBaseSourceAndDestinationComponent();

      DesignerBingSourceComponent.prototype.getData = function () {
        const data = DesignerBaseSourceAndDestinationComponent.prototype.getData.call(this);

        _.extend(data, {
          connection: this.connection.getData(),
          api_version: this.api_version,
          cloud_storage_connection_id: String(this.connection.id || ''),
          accounts_campaigns: this.accounts_campaigns || this.defaults.accounts_campaigns,
          report_type: this.report_type || this.defaults.report_type,
          columns: this.columns || this.defaults.columns,
          report_aggregation_type: this.report_aggregation_type || this.defaults.report_aggregation_type,
          report_date_range_type: this.report_date_range_type || this.defaults.report_date_range_type,
          report_date_range_min: this.report_date_range_min || this.defaults.report_date_range_min,
          report_date_range_max: this.report_date_range_max || this.defaults.report_date_range_max,
          time_period_date_field_alias: this.time_period_date_field_alias || this.defaults.time_period_date_field_alias,
          time_period_hour_field_alias: this.time_period_hour_field_alias || this.defaults.time_period_hour_field_alias,
          time_zone: this.time_zone || this.defaults.time_zone,
          report_on: this.report_on || this.defaults.report_on,
        });

        return data;
      };

      DesignerBingSourceComponent.prototype.setFormData = function (data) {
        // if (data.report_on === 'all') data.accounts_campaigns = '';
        // else if (!data.accounts_campaigns) data.report_on = 'all';

        const dateFieldIndex = _.findIndex(data.schema.fields, { name: 'time_period_date' });

        if (dateFieldIndex > -1) {
          data.time_period_date_field_alias = data.schema.fields[dateFieldIndex].alias;
          data.schema.fields.splice(dateFieldIndex, 1);
        }

        const hourFieldIndex = _.findIndex(data.schema.fields, { name: 'time_period_hour' });

        if (hourFieldIndex > -1) {
          data.time_period_hour_field_alias = data.schema.fields[hourFieldIndex].alias;
          data.schema.fields.splice(hourFieldIndex, 1);
        }

        this.setData(data);
        DesignerBaseSourceAndDestinationComponent.prototype.setFormData.call(this, data);
      };

      DesignerBingSourceComponent.prototype.setData = function (data) {
        this.cloud_storage_connection_id = String(this.connection.id || '');
        this.connection.setData(data.connection);
        this.api_version = data.api_version || data.defaults.api_version;
        this.accounts_campaigns = data.accounts_campaigns;
        this.report_type = data.report_type;
        this.columns = data.columns;
        this.report_aggregation_type = data.report_aggregation_type;
        this.report_date_range_type = data.report_date_range_type;
        this.report_date_range_min = data.report_date_range_min;
        this.report_date_range_max = data.report_date_range_max;
        this.time_period_date_field_alias = data.time_period_date_field_alias;
        this.time_period_hour_field_alias = data.time_period_hour_field_alias;
        this.time_zone = data.time_zone;

        this.report_on = data.report_on;
        if (!this.report_on) {
          if (!this.accounts_campaigns) this.report_on = 'all';
          else if (this.accounts_campaigns.charAt(0) === '$') this.report_on = 'custom';
          else this.report_on = 'specific';
        }

        if (this.report_on === 'all') {
          this.profile_ids = '';
        }

        DesignerBaseSourceAndDestinationComponent.prototype.setData.call(this, data);
      };

      DesignerBingSourceComponent.prototype.getSchema = function () {
        const schema = DesignerBaseSourceAndDestinationComponent.prototype.getSchema.call(this);

        if (this.time_period_hour_field_alias && this.time_period_hour_field_alias.length > 0) {
          schema.fields.unshift({
            name: this.time_period_hour_field_alias,
          });
        }

        if (this.time_period_date_field_alias && this.time_period_date_field_alias.length > 0) {
          schema.fields.unshift({
            name: this.time_period_date_field_alias,
          });
        }

        return schema;
      };

      return DesignerBingSourceComponent;
    },
  ]);
})(window.angular);
